







































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import { priUrlReg } from '@/apps/open/constants'
import Button from '@components/Button'
import { ElForm } from 'element-ui/types/form'
import { getDocEditCbConfig, setDocEditCbConfig } from '@/apps/open/services/app'
import Question from '@/apps/open/components/Question'

@Component({
  components: {
    ContentLayout,
    Button,
    Question
  }
})
export default class Callback extends Vue {
  form = {
    callback_url: '',
    is_app_doc: false,
    is_cache_user: false,
    edit_info: '',
    file_info: '',
    user_info: '',
    file_save: '',
    file_version: '',
    file_history: '',
    file_rename: '',
    file_online: '',
    // file_new: '',
    onnotify: '',
    user_auth: '',
    version_notify: ''
  }

  isEditMsg: string = '开启应用文档存储服务确保已经开通应用文档能力！否则接口会无法使用'
  isCacheMsg: string = '开启用户信息缓存后，文档中台将通过获取文件编辑信息缓存用户信息，降低文档中台回调接口调用量，但可能会导致用户信息更新延迟。'

  loading: boolean = false

  $refs!: {
    form: ElForm
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的回调域名', trigger: ['blur', 'change'] } : { type: 'url', message: '请输入正确的回调域名', trigger: ['blur', 'change'] }
    let compCheckRule = {}
    if (!this.form.is_app_doc) {
      compCheckRule = {
        file_info: [
          { required: true, message: '请填写获取文件元数据接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ],
        file_save: [
          { required: true, message: '请填写上传文件新版本接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ],
        file_version: [
          { required: true, message: '请填写获取指定版本信息接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ],
        file_history: [
          { required: true, message: '请填写获取所有版本信息接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ]
      }
    } else {
      compCheckRule = {
        edit_info: [
          { required: true, message: '请填写获取文件编辑信息接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ],
        user_auth: [
          { required: true, message: '请填写获取用户id接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ],
        version_notify: [
          { required: true, message: '请填写新版本推送接口配置', trigger: ['blur', 'change'] },
          { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
        ]
      }
    }
    return {
      callback_url: [
        { required: true, message: '请填写回调域名', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] },
        urlRule
      ],
      user_info: [
        { required: true, message: '请填写获取用户信息接口配置', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ],
      ...compCheckRule,
      file_rename: [
        { required: true, message: '请填写文件重命名接口配置', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ],
      file_online: [
        { required: true, message: '请填写获取文件状态接口配置', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ],
      /* file_new: [
        { required: true, message: '请填写新建文件接口配置', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ], */
      onnotify: [
        { required: true, message: '请填写回调通知接口配置', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ]
    }
  }

  isEdit: boolean = false

  get appId () {
    return this.$route.params.id
  }

  mounted () {
    this.getCallbackInfo()
  }

  initIsCacheStatus (isEdit: boolean) {
    if (!isEdit) {
      this.form.is_cache_user = false
    }
  }

  checkFormData () {
    if (this.form.is_app_doc) {
      this.form.file_info = ''
      this.form.file_save = ''
      this.form.file_version = ''
      this.form.file_history = ''
    } else {
      this.form.edit_info = ''
      this.form.user_auth = ''
      this.form.version_notify = ''
    }
  }

  saveCallbackConfig () {
    this.$refs.form.validate(async (valid: boolean) => {
      if (valid) {
        this.checkFormData()
        const params = this.form
        const res = await setDocEditCbConfig(this.appId, params)
        if (res.data.result === 'ok') {
          this.$message.success('更新成功')
        }
      }
    })
  }

  async getCallbackInfo () {
    const res = await getDocEditCbConfig(this.appId)
    if (res.data.result === 'ok') {
      const info = res.data.object
      this.form = info
    }
  }
}
